import { Component, OnInit } from '@angular/core';
import { ApiVersionService } from '../../services';
import { Message } from '../../classes/Message';
import { MessageService } from 'primeng';

@Component({
  selector: 'api-version',
  template: `<div style="display: none;"></div>`,
})
export class ApiVersionComponent implements OnInit {
  private messageAlreadyShown = false;

  constructor(
    private apiVersionService: ApiVersionService,
    private messagesService: MessageService,
  ) {}

  ngOnInit(): void {
    this.apiVersionService.onVersionChanged.subscribe(() => {
      this.showMessage();
    });
  }

  private showMessage() {
    if (!this.messageAlreadyShown) {
      this.messageAlreadyShown = true;
      this.messagesService.add(Message.Warning('API version has changed. Please reload the page'));
    }
  }
}
